<template>
  <main style="background-color: #1D1D1B;">
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div class="page_title" style="display: flex;justify-content: center;">
            <div>
              <h3 class="page_title" style="display: inline-block;
            height: 4.1rem;
            border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Industry News </h3>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; width: 100%;justify-content:right;padding-right: 15%;">
        <SearchInput v-model="inputValue" style="width: 345px;" />
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">

      </div>
    </section>
    <section>

      <div class="page_content" style="min-height: 800px;">
        <div>

          <div>
            <table>
              <tr>
                <td class=" col-md-1-1" style="vertical-align: top; padding: 0;background-color: #1D1D1B;">
                  <div class="tree-box" style="width: 100%;min-width: 240px;">

                    <div class="tree-content" style="margin-top: 20px;">
                      <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                        :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                        @cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false"
                        :expand-on-click-node="false" @node-click="handleNodeClick">
                        <span slot-scope="{ data }" class="custom-tree-node">
                          <template>
                            <div class="node_div">
                              <span class="name-box">
                                {{ data.name }}<span v-if="data.itemNum>0">({{data.itemNum}})</span>
                              </span>
                            </div>
                          </template>
                        </span>
                      </el-tree>
                    </div>
                  </div>
                </td>
                <td class="container col-md-10-1"
                  style="vertical-align: top;padding: 0;padding-left: 10%;padding-right: 15%;">
                  <section >
                  <!-- <section data-aos="fade-up"> -->
                    <div class=" row news_content" v-for="item in newsData" :key="item.id" @click="navigateTo(item.id)">
                      <div class="col-md-1-1 content_padding news_content_date">
                        <div class="card-body news_content_date_body">
                          <h3> {{item.monthDay}} </h3>
                          <p>— {{item.year}} —</p>
                        </div>
                      </div>

                      <div class="col-md-7-1 content_padding">
                        <div class="overlay  border-0 text-left pb-2">
                          <h5 class="card-title news_title">{{item.title}}</h5>
                          <p class="card-text text-muted">
                            {{item.summary}}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-3 content_padding">
                        <div class="overlay border-0">
                          <img class="card-img" :src="item.url" alt="Card image" style="height: 165px;width: 333px">
                        </div>
                      </div>
                    </div>
                     <!-- 弹窗 -->
                    <div v-if="dialogVisible" class="popup" style="width: 75%;height: 92%;max-width: 1000px;">
                      
                      <div style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
                        <img src="/assets/img/Main/popMin.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">
                        <img src="/assets/img/Main/popMax.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">
                        <img src="/assets/img/Main/popExit.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">

                      </div>
                      
                      <div style="overflow: auto;max-height: 845px;">
                        <div>
                              <h3 style="display: inline-block;height: 50px;color: rgb(252, 180, 46);padding-top: 15px;">News </h3>
                            </div>
                        <div v-html="currentContent" style="text-align: left;padding-left: 10px;padding-right: 10px; ">
                        </div>
                      </div>


                    </div>
                  </section>
                </td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </section>
  </main>

</template>


<script>
  import SearchInput from '@/components/common/SearchInput.vue';
  import { getNewsNoContentList, getNewsTreeList} from "@/api/rbac/news";
  export default {
    name: 'News',
    components: {
      SearchInput
    },
    data() {
      return {
        inputValue: '',
        slides: [
          { date: '2022/11/24', img: require('../../../public/assets/img/News/news_primary.png'), title: '2022 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionals  from the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
          { date: '2023/11/24', img: require('../../../public/assets/img/News/news1.png'), title: '2023 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionals from the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
          { date: '2024/11/24', img: require('../../../public/assets/img/News/news2.png'), title: '2024 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionalsfrom the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
        ],
        currentPage: 1,  // 当前显示的页面
        itemsPerPage: 1,  // 每页显示3张图片
        newsData: [],
        treeData: [{
          id: 1, name: 'News', value: 0, children: [{ id: 2, name: '2023 Year', value: 2023 }, { id: 3, name: '2024 Year', value: 2024 }, { id: 4, name: '2025 Year', value: 2025 }]
        }],
        isLeftExp: true,
        dialogVisible: false,//新联详情弹窗
        currentContent: '',//新联详情
      };
    },

    created() {
      this.getNewsTreeList();
    },
    computed: {
      slidesgroup() {
        return Math.ceil(this.slides.length);
      },
      displayedSlides() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;

        return this.slides.slice(start, end);
      }
    },
    methods: {
      navigateTo(id) {
        // this.$router.push(`${this.$route.path}/name`);

        this.$router.push(`${this.$route.path}/1/` + id);
        // try {
        //   getNewsAllList({ tableType: 1, strWhere: ' and a.id=' + id }).then((res) => {

        //     if (res.data.length == 0) {
        //       this.currentContent = '';
        //     }
        //     else {
        //       this.currentContent = res.data[0].content;
        //     }
        //   });

        // } catch (error) {
        //   console.log(error);
        // }

        // this.dialogVisible = true;
      },
      setDefaultNode(id) {
        // 假设你想默认聚焦的节点的 id 是 5
        this.$nextTick(() => {
          const tree = this.$refs.treeleft;
          const node = tree.getNode(id);
          if (node) {
            tree.setCurrentKey(id);
            this.loadDataList(` and a.year='${node.data.realID}'`)

            //tree.setCurrentNode(node); // 可选，根据需求选择是否使用
          }
        });
      },
      handleNodeClick(node) {
        if (node.pID == 0) {
          this.loadDataList('')
        }
        else {
          this.loadDataList(` and a.year='${node.realID}'`)
        }
      },
      getNewsTreeList() {
        getNewsTreeList({ tableType: 1, strWhere: '' }).then(res => {
          this.treeData = res.data;
          // this.setDefaultNode(4)
          if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
            this.$nextTick(() => {
              this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
            });
          }
          this.loadDataList('')
        })
      },
      async loadDataList(strWhere) {
        try {
          getNewsNoContentList({ tableType: 1, strWhere: strWhere }).then(res => {
            if (res.data.length == 0) {
              // console.log(this.dataList)
              this.newsData = [];
            }
            else {
              this.newsData = res.data;
              this.newsData.forEach(comNew => {
                comNew.url = "../../../assets/img/News/" + comNew.url;
              });
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
    },
    mounted() {
      // this.setDefaultNode(4);
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
    min-height: 100vh;
  }

  ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  :deep(.el-tree-node:focus >.el-tree-node__content) {
    background-color: #FCB42E !important;
  }

  /* :deep(.el-tree-node) {
          background-color: transparent !important;
      }
      :deep(.el-tree) {
          background-color: transparent;
      }
    :deep(.el-tree-node__content:hover) {
          background-color: #FCB42E !important;
        }
        :deep(.el-tree-node:focus >.el-tree-node__content){
          background-color: #FCB42E !important;
        }
        :deep(.el-tree--highlight-current .el-tree-node.is-current .el-tree-node__content)
        {
          background-color: #FCB42E !important;
        } */


  :deep(.page_search) {
    display: flex;
    justify-content: right;
  }

  :deep(.news_content) {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #353535;
  }

  :deep(.news_content:hover) {
    background-color: #171717;
  }

  :deep(.news_content_date) {
    padding: 4rem 0;
  }

  :deep(.news_content:hover .news_content_date) {
    background-color: #FCB42E;
  }

  :deep(.news_content_date_body) {
    padding: auto;
    color: #fff;
  }

  :deep(.news_content:hover .news_content_date_body) {
    color: #000;
  }

  :deep(.news_title) {
    color: #fff;
  }

  :deep(.news_content:hover .news_title) {
    color: #FCB42E;
  }
  .popup {
		position: fixed;
		top: 53%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #424242;
		/* border: 1px solid #ccc; */
		border-bottom: 10px solid #262626;
		border-left: 10px solid #262626;
		border-right: 10px solid #262626;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		z-index: 1000;
	}
</style>